import React from 'react';
import RadioSelect from '../../../FormElements/RadioSelect/RadioSelect';
import RadioGroup from '@material-ui/core/RadioGroup';
import Grid from '@material-ui/core/Grid';

export const validOptions = ["SI","SD","RC"];

function CeilingType(props) {

  const {configuration,createItem,setNextEnabled} = props;


  function handleChange(event, value) {
    setNextEnabled(true);
    createItem({id:"ceilingType",value:value});
  }
  
  return (
    <RadioGroup
      aria-label="Ceiling Type"
      name="ceilingType"
      onChange={handleChange}
      defaultValue={configuration["ceilingType"] ? configuration["ceilingType"] : ''}
    >
      <Grid container spacing={3}>
        <Grid item md={3}>
          <RadioSelect disabled={!validOptions.includes(configuration.mountingOptions)} value="A" label="1” T bar"/>
        </Grid>
        <Grid item md={3}>
          <RadioSelect disabled={!validOptions.includes(configuration.mountingOptions)} value="B" label="9/16” T bar"/>
        </Grid>
        <Grid item md={3}>
          <RadioSelect disabled={!validOptions.includes(configuration.mountingOptions)} value="C" label="Screw Slot T bar"/>
        </Grid>
        <Grid item md={3}>
          <RadioSelect disabled={!validOptions.includes(configuration.mountingOptions)} value="D" label="Hard Ceiling"/>
        </Grid>
        {configuration.mountingOptions==="RC" ?
          <React.Fragment>
            <Grid item md={3}>
              <RadioSelect value="E" label="1” Tegular"/>
            </Grid>
            <Grid item md={3}>
              <RadioSelect value="F" label="9/16” Tegular"/>
            </Grid>
            <Grid item md={3}>
              <RadioSelect value="G" label="Overlap Flange"/>
            </Grid>
          </React.Fragment>
          :
          <React.Fragment>
            <Grid item md={3}>
              <RadioSelect disabled={true} value="E" label="1in Tegular"/>
            </Grid>
            <Grid item md={3}>
              <RadioSelect disabled={true} value="F" label="9/16in Tegular"/>
            </Grid>
            <Grid item md={3}>
              <RadioSelect disabled={true} value="G" label="Overlap Flange"/>
            </Grid>
          </React.Fragment>
        }
      </Grid>
    </RadioGroup>
  );
}

export default CeilingType;